type Props = {};

function LogoV2({}: Props) {
  return (
    <img
      src="https://vealth1st-logo-bucket.s3.ap-south-1.amazonaws.com/vealth1st_logo_colored+(1).png"
      alt="logo"
      height="50px"
      width="150px"
      onError={(e) => {
        e.currentTarget.onerror = null;
        e.currentTarget.src = '/vealth1st-logo-blue.png';
      }}
    />
  );
}

export default LogoV2;

